
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import config from '@/config'
import { getUserAccount } from '@/api/user.js'
import { getActivitylist } from '@/api/youzheng.js'
import success from '@/assets/success.png'
import fail from '@/assets/fail.png'
import Scroll from '@/components/scroller'
import { getaddlog } from '@/api/hgfw'
export default {
name: 'bulk',
components: {
Group,
Cell,
Scroll
},
data () {
return {
baseUrl: config.baseUrl + '/',
list: [],
page: 1,
rows: 10,
currentTime: '',
success: success,
fail: fail,
notFirstLoad: false,
loadMoreDom: null,
listDom: null,
activity: 0
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {

getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120115
}).then(res => { })
},
getlist (type, done) {
getActivitylist({
page: this.page,
rows: this.rows,
acGenre: 1
})
.then(res => {
this.notFirstLoad = true
if (type === 'refresh' || type === 'search') {
this.list = []
this.listDom.scrollTop = 0
}
if (res.returnValue.rows !== '' && res.returnValue.rows.length > 0) {
res.returnValue.rows.forEach((item, index) => {
this.$set(this.list, this.list.length, item)
})
}
if (
res.returnValue.rows.length === 0 ||
res.returnValue.rows.length < this.rows
) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
this.list.forEach((item, index) => {
let signstartdate = item.signstartdate.replace(/-/g, '/')
let signenddate = item.signenddate.replace(/-/g, '/')
signstartdate = new Date(signstartdate).getTime()
signenddate = new Date(signenddate).getTime()
if (
parseInt(this.currentTime) < parseInt(signenddate) &&
parseInt(this.currentTime) >= parseInt(signstartdate)
) {
this.$set(this.list[index], 'activity', 1)
return false
}
if (parseInt(this.currentTime) < parseInt(signstartdate)) {
this.$set(this.list[index], 'activity', 2)
return false
}
if (parseInt(this.currentTime) >= parseInt(signenddate)) {
this.$set(this.list[index], 'activity', 3)
return false
}
})
done && done()
})
.catch(e => { })
},
goDetail (item) {
if (item.activity == 2) {
let date1 = new Date() 
let date2 = item.signstartdate.replace(/-/g, '/') 
let date3 = new Date(date2).getTime() - date1.getTime() 

let days = Math.floor(date3 / (24 * 3600 * 1000))

let leave1 = date3 % (24 * 3600 * 1000) 
let hours = Math.floor(leave1 / (3600 * 1000))

let leave2 = leave1 % (3600 * 1000) 
let minutes = Math.floor(leave2 / (60 * 1000))

let leave3 = leave2 % (60 * 1000) 
let seconds = Math.round(leave3 / 1000)

this.$vux.toast.text(
'离开始时间还剩' +
days +
'天' +
hours +
'时' +
minutes +
'分' +
seconds +
'秒',
'middle'
)
} else {
if (item.link !== '') {
window.location.href = item.link
} else {
this.$router.push({ name: 'tuanGouDetail', params: { id: item.id } })
}
}
},

refresh (done, index) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getlist('refresh', done)
},

loadMore (done, index) {
this.page++
this.getlist('more', done)
}
},
created () {
this.getlist()
},
activated () {
this.listDom.scrollTop = config.scrollPosition.y
},
beforeRouteLeave (to, from, next) {
config.scrollPosition.y = this.listDom.scrollTop
next()
},
mounted () {
let timestamp = new Date().getTime()
this.currentTime = timestamp
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
}
}
